import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import { 
  AUTOREVIEW_DETAIL,
  AUTOREVIEW_SEARCH,
  AUTOREVIEW_ADD,
  AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST,
  AUTOREVIEW_SEARCH_SUPPLIER_LIST,
  AUTOREVIEW_LIST,
  AUTOREVIEW_UPDATE,
} from '../actions';

import {
  AutoReviewDetailSuccess,
  AutoReviewDetailError,
  AutoReviewSearchSuccess,
  AutoReviewSearchError,
  AutoReviewAddSuccess,
  AutoReviewAddError,
  AutoReviewSearchAutoReviewStateListSuccess,
  AutoReviewSearchAutoReviewStateListError,
  AutoReviewSearchSupplierListSuccess,
  AutoReviewSearchSupplierListError,
  AutoReviewListSuccess,
  AutoReviewListError,
  AutoReviewUpdateSuccess,
  AutoReviewUpdateError,
} from '../actions';

export function* watchAutoReviewDetail() {
  yield takeEvery(AUTOREVIEW_DETAIL, onAutoReviewDetail);
}

export function* watchAutoReviewSearch() {
  yield takeEvery(AUTOREVIEW_SEARCH, onAutoReviewSearch);
}

export function* watchAutoReviewAdd() {
  yield takeEvery(AUTOREVIEW_ADD, onAutoReviewAdd);
}

export function* watchAutoReviewSearchAutoReviewStateList() {
  yield takeEvery(AUTOREVIEW_SEARCH_AUTOREVIEW_STATE_LIST, onAutoReviewSearchAutoReviewStateList);
}

export function* watchAutoReviewSearchSupplierList() {
  yield takeEvery(AUTOREVIEW_SEARCH_SUPPLIER_LIST, onAutoReviewSearchSupplierList);
}

export function* watchAutoReviewList() {
  yield takeEvery(AUTOREVIEW_LIST, onAutoReviewList);
}

export function* watchAutoReviewUpdate() {
  yield takeEvery(AUTOREVIEW_UPDATE, onAutoReviewUpdate);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAutoReviewDetailAsync  = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'autoreview/get', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAutoReviewSearchAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'autoreview/search', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAutoReviewAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'autoreview/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAutoReviewSearchAutoReviewStateListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/autoreview_state', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAutoReviewSearchSupplierListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/supplier', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAutoReviewListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'autoreview/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAutoReviewUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'autoreview/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

function* onAutoReviewSearch(data) {
  try {
    const response = yield call(onAutoReviewSearchAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(AutoReviewSearchSuccess(response.data.data));
  } catch (error) {
    console.log('catch error', error)
    yield put(AutoReviewSearchError(error));
  }
}

function* onAutoReviewAdd(data) {
  try {
    const response = yield call(onAutoReviewAddAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(AutoReviewAddSuccess(response.data.data));
  } catch (error) {
    console.log('catch error', error)
    yield put(AutoReviewAddError(error));
  }
}

function* onAutoReviewDetail(data) {
  try {
    const response = yield call(onAutoReviewDetailAsync, data);
    yield put(AutoReviewDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AutoReviewDetailError(error));
  }
}

function* onAutoReviewSearchAutoReviewStateList(data) {
  try {
    const response = yield call(onAutoReviewSearchAutoReviewStateListAsync, data);
    yield put(AutoReviewSearchAutoReviewStateListSuccess(response.data));
  } catch (error) {
    yield put(AutoReviewSearchAutoReviewStateListError(error));
  }
}

function* onAutoReviewSearchSupplierList(data) {
  try {
    const response = yield call(onAutoReviewSearchSupplierListAsync, data);
    yield put(AutoReviewSearchSupplierListSuccess(response.data));
  } catch (error) {
    yield put(AutoReviewSearchSupplierListError(error));
  }
}

function* onAutoReviewList(data) {
  try {
    const response = yield call(onAutoReviewListAsync, data.payload);
    yield put(AutoReviewListSuccess(response.data));
  } catch (error) {
    yield put(AutoReviewListError(error));
  }
}

function* onAutoReviewUpdate(data) {
  try {
    const response = yield call(onAutoReviewUpdateAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(AutoReviewUpdateSuccess(response.data));
  } catch (error) {
    yield put(AutoReviewUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchAutoReviewDetail),
    fork(watchAutoReviewSearch),
    fork(watchAutoReviewSearchAutoReviewStateList),
    fork(watchAutoReviewSearchSupplierList),
    fork(watchAutoReviewList),
    fork(watchAutoReviewAdd),
    fork(watchAutoReviewUpdate),
  ]);
}